export const totalMembersCountSelector = state => state.member.totalMembersCount;
export const setDeepLinkSelector = state => state.member.deepLink;
